import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

const GlobeIcon = () => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    width="16" 
    height="16" 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="10" />
    <path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20" />
    <path d="M2 12h20" />
  </svg>
);

const languages = [
  { code: 'ja', label: '日本語', shortLabel: 'JA' },
  { code: 'en', label: 'English', shortLabel: 'EN' },
  { code: 'zh', label: '中文', shortLabel: 'ZH' },
  { code: 'ko', label: '한국어', shortLabel: 'KO' },
];

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // i18n.language プレフィックス一致対応 (e.g. ja-JP -> ja)
  const currentCode = (i18n.language || 'ja').split('-')[0];
  const currentLang = languages.find((l) => l.code === currentCode) || languages[0];

  const handleChange = (code) => {
    i18n.changeLanguage(code);
    setIsOpen(false);
  };

  // ドロップダウン外クリックで閉じる
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="lang-switcher" ref={dropdownRef}>
      <button
        className={`lang-switcher-btn ${isOpen ? 'is-active' : ''}`}
        onClick={() => setIsOpen((v) => !v)}
        aria-expanded={isOpen}
        aria-label="Language Selector"
      >
        <span className="lang-globe-icon">
          <GlobeIcon />
        </span>
        <span className="lang-code-text">{currentLang.shortLabel}</span>
        <svg 
          className={`lang-chevron ${isOpen ? 'open' : ''}`} 
          width="10" 
          height="6" 
          viewBox="0 0 10 6" 
          fill="none" 
          stroke="currentColor" 
          strokeWidth="1.5" 
          strokeLinecap="round" 
          strokeLinejoin="round"
        >
          <path d="M1 1L5 5L9 1" />
        </svg>
      </button>

      {isOpen && (
        <ul className="lang-dropdown">
          {languages.map((lang) => (
            <li key={lang.code}>
              <button
                className={`lang-option ${lang.code === currentCode ? 'active' : ''}`}
                onClick={() => handleChange(lang.code)}
              >
                <span className="lang-option-code">{lang.shortLabel}</span>
                <span className="lang-option-name">{lang.label}</span>
                {lang.code === currentCode && (
                  <span className="lang-check-icon">✓</span>
                )}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default LanguageSwitcher;
